export const MESSAGE_TYPES = {
  OPEN_OPTIONS: "lotlingo/open-options",
  HEAD_REQUEST: "lotlingo/head-request",
  UPLOAD: "lotlingo/upload",
  UPLOAD_STATUS: "lotlingo/upload-status",
  NEW_SUBMISSION: "lotlingo/new-submission",
  SCRAPE_URL: "lotlingo/scrape-url",
  LOG_BID: "lotlingo/log-bid",
  TELEMETRY: "lotlingo/telemetry",
  BEGIN_AUTH: "lotlingo/begin-auth",
  GET_TRACKED_LOTS: "lotlingo/get-tracked-lots",
} as const;

export type MessageType = (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];

export const STORAGE_KEYS = {
  EXTENSION_AUTH: "extensionAuth",
  HOME_ZIP: "homeZip",
} as const;

export const WINDOW_EVENT_NAMES = {
  COLLECT_WINDOW_IMAGES_ACK: "lotlingo:collect-window-images-ack",
} as const;

export const TELEMETRY_EVENTS = {
  COLLECT_WINDOW_IMAGES_TIMEOUT: "collectWindowImagesTimeout",
} as const;

export const EXTENSION_IDENTIFIERS = {
  IDENTITY_REDIRECT_PATH: "lotlingo-extension",
} as const;
